import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { WarEntity } from ".";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedWarEntity(war_id: number): Promise<WarEntity | null> {
  let entity: any = await cache.get(war_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const war = await esiClient.get_wars_war_id(null, null, war_id);
    if (war !== null) {
      entity = new WarEntity(war_id, war);
      cache.put(war_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
